/** Estado efêmero da tela do mapa (sobrevive à troca de seção, não ao recarregar). */
import { create } from 'zustand';
import type { Camera } from './engine';

interface MapState {
  selected: string | null;
  camera: Camera | null;
  goTo: string | null;
  search: string;
  fullscreen: boolean;
  set: (p: Partial<Omit<MapState, 'set'>>) => void;
}
export const useMapState = create<MapState>(set => ({
  selected: null, camera: null, goTo: null, search: '', fullscreen: false,
  set: p => set(p),
}));
